import React from 'react';

import {REMOTE_CONFIG_PATHS} from '../../../constants/remoteConfigPaths';
import {DynamicContent} from '../../DynamicContent';

export const TextDataSharing = () => (
  <DynamicContent
    configPath={REMOTE_CONFIG_PATHS.PRIVACY_POLICY.DATA_SHARING}
    renderAsHtml={true}
  />
);
